// Welcome, step one: a name and a language (A5U20), on the welcome steps' card (A13U1, board getin-you). Owned by hand
// from here on.
import { ids } from '@orca/api-client/testIds'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { OnboardingFrame } from '../../features/onboarding/OnboardingFrame'
import { ProfileStep } from '../../features/onboarding/ProfileStep'
import { meQuery } from '../../shared/org/me'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/welcome/profile')({
  staticData: { screenId: 'OnboardingProfileScreen', access: 'verified, no organization' },
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(meQuery()),
  component: OnboardingProfileScreen,
})

function OnboardingProfileScreen() {
  const { t } = useTranslation()
  const { data: me } = useSuspenseQuery(meQuery())
  const first = me?.user?.displayName?.trim().split(/\s+/)[0]
  return (
    <OnboardingFrame
      testId={ids.onboardingProfile.root}
      step={1}
      title={first ? t('onboarding.profile.hi', { name: first }) : t('onboarding.profile.title')}
      lead={t('onboarding.profile.lead')}
      accountTestId={ids.onboardingProfile.accountButton}
    >
      <Part testId={ids.onboardingProfile.skeleton}>
        <ProfileStep />
      </Part>
    </OnboardingFrame>
  )
}
